const icons = [
    { name: "0", class: "fa-thin fa-0" },
    { name: "0", class: "fa-solid fa-0" },
    { name: "0", class: "fa-regular fa-0" },
    { name: "0", class: "fa-light fa-0" },
    { name: "1", class: "fa-thin fa-1" },
    { name: "1", class: "fa-solid fa-1" },
    { name: "1", class: "fa-regular fa-1" },
    { name: "1", class: "fa-light fa-1" },
    { name: "2", class: "fa-thin fa-2" },
    { name: "2", class: "fa-solid fa-2" },
    { name: "2", class: "fa-regular fa-2" },
    { name: "2", class: "fa-light fa-2" },
    { name: "3", class: "fa-thin fa-3" },
    { name: "3", class: "fa-solid fa-3" },
    { name: "3", class: "fa-regular fa-3" },
    { name: "3", class: "fa-light fa-3" },
    { name: "4", class: "fa-thin fa-4" },
    { name: "4", class: "fa-solid fa-4" },
    { name: "4", class: "fa-regular fa-4" },
    { name: "4", class: "fa-light fa-4" },
    { name: "42-Group", class: "fa-brands fa-42-group" },
    { name: "5", class: "fa-thin fa-5" },
    { name: "5", class: "fa-solid fa-5" },
    { name: "5", class: "fa-regular fa-5" },
    { name: "5", class: "fa-light fa-5" },
    { name: "500-Px", class: "fa-brands fa-500px" },
    { name: "6", class: "fa-thin fa-6" },
    { name: "6", class: "fa-solid fa-6" },
    { name: "6", class: "fa-regular fa-6" },
    { name: "6", class: "fa-light fa-6" },
    { name: "7", class: "fa-thin fa-7" },
    { name: "7", class: "fa-solid fa-7" },
    { name: "7", class: "fa-regular fa-7" },
    { name: "7", class: "fa-light fa-7" },
    { name: "8", class: "fa-thin fa-8" },
    { name: "8", class: "fa-solid fa-8" },
    { name: "8", class: "fa-regular fa-8" },
    { name: "8", class: "fa-light fa-8" },
    { name: "9", class: "fa-thin fa-9" },
    { name: "9", class: "fa-solid fa-9" },
    { name: "9", class: "fa-regular fa-9" },
    { name: "9", class: "fa-light fa-9" },
    { name: "A", class: "fa-solid fa-a" },
    { name: "Accessible-Icon", class: "fa-brands fa-accessible-icon" },
    { name: "Accusoft", class: "fa-brands fa-accusoft" },
    { name: "Adn", class: "fa-brands fa-adn" },
    { name: "Adversal", class: "fa-brands fa-adversal" },
    { name: "Affiliatetheme", class: "fa-brands fa-affiliatetheme" },
    { name: "Airbnb", class: "fa-brands fa-airbnb" },
    { name: "Algolia", class: "fa-brands fa-algolia" },
    { name: "Align-Center", class: "fa-solid fa-align-center" },
    { name: "Align-Justify", class: "fa-solid fa-align-justify" },
    { name: "Align-Left", class: "fa-solid fa-align-left" },
    { name: "Align-Right", class: "fa-solid fa-align-right" },
    { name: "Alipay", class: "fa-brands fa-alipay" },
    { name: "Amazon", class: "fa-brands fa-amazon" },
    { name: "Amazon-Pay", class: "fa-brands fa-amazon-pay" },
    { name: "Amilia", class: "fa-brands fa-amilia" },
    { name: "Anchor", class: "fa-solid fa-anchor" },
    { name: "Anchor-Circle", class: "fa-solid fa-anchor-circle" },
    { name: "Anchor-Circle-check", class: "fa-solid fa-anchor-circle-check" },
    { name: "Anchor-Circle-exclamation", class: "fa-solid fa-anchor-circle-exclamation" },
    { name: "Anchor-Circle-xmark", class: "fa-solid fa-anchor-circle-xmark" },
    { name: "Android", class: "fa-brands fa-android" },
    { name: "Angellist", class: "fa-brands fa-angellist" },
    { name: "Angle-Down", class: "fa-solid fa-angle-down" },
    { name: "Angle-Right", class: "fa-solid fa-angle-right" },
    { name: "Angle-Left", class: "fa-solid fa-angle-left" },
    { name: "Angle-Up", class: "fa-solid fa-angle-up" },
    { name: "Angles-Down", class: "fa-solid fa-angles-down" },
    { name: "Angles-Right", class: "fa-solid fa-angles-right" },
    { name: "Angles-Left", class: "fa-solid fa-angles-left" },
    { name: "Angles-Up", class: "fa-solid fa-angles-up" },
    { name: "Angular", class: "fa-brands fa-angular" },
    { name: "Ankh", class: "fa-solid fa-ankh" },
    { name: "App-Store", class: "fa-brands fa-app-store" },
    { name: "App-Store-IOS", class: "fa-brands fa-app-store-ios" },
    { name: "Apper", class: "fa-brands fa-apper" },
    { name: "Apple", class: "fa-brands fa-apple" },
    { name: "Apple-Pay", class: "fa-brands fa-apple-pay" },
    { name: "Apple-Whole", class: "fa-solid fa-apple-whole" },
    { name: "Archway", class: "fa-solid fa-archway" },
    { name: "Arrow-Down", class: "fa-solid fa-arrow-down" },
    { name: "Arrow-Down-1-9", class: "fa-solid fa-arrow-down-1-9" },
    { name: "Arrow-Down-9-1", class: "fa-solid fa-arrow-down-9-1" },
    { name: "Arrow-Down-A-Z", class: "fa-solid fa-arrow-down-a-z" },
    { name: "Arrow-Down-Long", class: "fa-solid fa-arrow-down-long" },
    { name: "Arrow-Down-Short-Wide", class: "fa-solid fa-arrow-down-short-wide" },
    { name: "Arrow-Down-Up-Across-Line", class: "fa-solid fa-arrow-down-up-across-line" },
    { name: "Arrow-Down-Up-Lock", class: "fa-solid fa-arrow-down-up-lock" },
    { name: "Arrow-Down-Wide-Short", class: "fa-solid fa-arrow-down-wide-short" },
    { name: "Arrow-Down-Z-A", class: "fa-solid fa-arrow-down-z-a" },
    { name: "Arrow-Left", class: "fa-solid fa-arrow-left" },
    { name: "Arrow-Left-Long", class: "fa-solid fa-arrow-left-long" },
    { name: "Arrow-Pointer", class: "fa-solid fa-arrow-pointer" },
    { name: "Arrow-Right", class: "fa-solid fa-arrow-right" },
    { name: "Arrow-Right-Arrow-Left", class: "fa-solid fa-arrow-right-arrow-left" },
    { name: "Arrow-Right-From-Bracket", class: "fa-solid fa-arrow-right-from-bracket" },
    { name: "Arrow-Right-Long", class: "fa-solid fa-arrow-right-long" },
    { name: "Arrow-Right-To-Bracket", class: "fa-solid fa-arrow-right-to-bracket" },
    { name: "Arrow-Right-To-City", class: "fa-solid fa-arrow-right-to-city" },
    { name: "Arrow-Rotate-Left", class: "fa-solid fa-arrow-rotate-left" },
    { name: "Arrow-Rotate-Right", class: "fa-solid fa-arrow-rotate-right" },
    { name: "Arrow-Trend-Down", class: "fa-solid fa-arrow-trend-down" },
    { name: "Arrow-Trend-Up", class: "fa-solid fa-arrow-trend-up" },
    { name: "Arrow-Turn-Down", class: "fa-solid fa-arrow-turn-down" },
    { name: "Arrow-Turn-Up", class: "fa-solid fa-arrow-turn-up" },
    { name: "Arrow-Up", class: "fa-solid fa-arrow-up" },
    { name: "Arrow-Up-1-9", class: "fa-solid fa-arrow-up-1-9" },
    { name: "Arrow-Up-9-1", class: "fa-solid fa-arrow-up-9-1" },
    { name: "Arrow-Up-A-Z", class: "fa-solid fa-arrow-up-a-z" },
    { name: "Arrow-Up-From-Bracket", class: "fa-solid fa-arrow-up-from-bracket" },
    { name: "Arrow-Up-From-Ground-Water", class: "fa-solid fa-arrow-up-from-ground-water" },
    { name: "Arrow-Up-From-Water-Pump", class: "fa-solid fa-arrow-up-from-water-pump" },
    { name: "Arrow-Up-Long", class: "fa-solid fa-arrow-up-long" },
    { name: "Arrow-Up-Right-Dots", class: "fa-solid fa-arrow-up-right-dots" },
    { name: "Arrow-Up-Right-From-Square", class: "fa-solid fa-arrow-up-right-from-square" },
    { name: "Arrow-Up-Short-Wide", class: "fa-solid fa-arrow-up-short-wide" },
    { name: "Arrow-Up-Wide-Short", class: "fa-solid fa-arrow-up-wide-short" },
    { name: "Arrow-Up-Z-A", class: "fa-solid fa-arrow-up-z-a" },
    { name: "Arrows-Down-To-Line", class: "fa-solid fa-arrows-down-to-line" },
    { name: "Arrows-Down-To-People", class: "fa-solid fa-arrows-down-to-people" },
    { name: "Arrows-Left-Right", class: "fa-solid fa-arrows-left-right" },
    { name: "Arrows-Left-Right-To-Line", class: "fa-solid fa-arrows-left-right-to-line" },
    { name: "Arrows-Rotate", class: "fa-solid fa-arrows-rotate" },
    { name: "Arrows-Spin", class: "fa-solid fa-arrows-spin" },
    { name: "Arrows-Split-Up-And-Left", class: "fa-solid fa-arrows-split-up-and-left" },
    { name: "Arrows-To-Circle", class: "fa-solid fa-arrows-to-circle" },
    { name: "Arrows-To-Dot", class: "fa-solid fa-arrows-to-dot" },
    { name: "Arrows-To-Eye", class: "fa-solid fa-arrows-to-eye" },
    { name: "Arrows-Turn-Right", class: "fa-solid fa-arrows-turn-right" },
    { name: "Arrows-Turn-To-Dots", class: "fa-solid fa-arrows-turn-to-dots" },
    { name: "Arrows-Up-Down", class: "fa-solid fa-arrows-up-down" },
    { name: "Arrows-Up-Down-Left-Right", class: "fa-solid fa-arrows-up-down-left-right" },
    { name: "Arrows-Up-To-Line", class: "fa-solid fa-arrows-up-to-line" },
    { name: "Artstation", class: "fa-brands fa-artstation" },
    { name: "Asterisk", class: "fa-solid fa-asterisk" },
    { name: "Asymmetrik", class: "fa-brands fa-asymmetrik" },
    { name: "At", class: "fa-solid fa-at" },
    { name: "Atlassian", class: "fa-brands fa-atlassian" },
    { name: "Atom", class: "fa-solid fa-atom" },
    { name: "Audible", class: "fa-brands fa-audible" },
    { name: "Audio-Description", class: "fa-solid fa-audio-description" },
    { name: "Austral-Sign", class: "fa-solid fa-austral-sign" },
    { name: "Autoprefixer", class: "fa-brands fa-autoprefixer" },
    { name: "Avianex", class: "fa-brands fa-avianex" },
    { name: "Aviato", class: "fa-brands fa-aviato" },
    { name: "Award", class: "fa-solid fa-award" },
    { name: "Aws", class: "fa-brands fa-aws" },

];


export default icons;